import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import Select, { IOption } from 'components/ui/abstract/Select'
import { IRegion, ISetSearchParams } from 'components/core/types'
import { IApplicationState } from 'components/store/types'
import { getActiveRegions, getCurrentRegion } from 'components/core/state/selectors'
import { AppDispatch } from 'components/store/state/store'
import { updateCurrentRegion } from 'components/core/state/actions'
import { SelectChangeEvent } from '@mui/material/Select/SelectInput'
import Spinner from 'components/ui/Spinner'

const formatRegionOptions = (regions: IRegion[]): IOption[] => regions
  .map(({ id, name, parent }: IRegion) => ({
    value: id,
    label: name,
    parent,
  }))

const mapState = (state: IApplicationState) => ({
  regions: getActiveRegions(state),
  currentRegion: getCurrentRegion(state),
})
const mapDispatch = (dispatch: AppDispatch) => ({
  updateRegion: (regionId: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentRegion(regionId, setSearchParams))
  },
})
const connector = connect(mapState, mapDispatch)

interface SelectRegionProps extends ConnectedProps<typeof connector> {
  big?: boolean,
}

const SelectRegion = ({
  big,
  currentRegion,
  regions,
  updateRegion,
}: SelectRegionProps) => {
  const [, setSearchParams] = useSearchParams()
  const [options, setOptions] = useState(formatRegionOptions(regions))
  const [selected, setSelected] = useState(currentRegion)
  const handleChange = (event: SelectChangeEvent) => {
    updateValue(parseInt(event.target.value, 10))
  }

  useEffect(() => {
    setOptions(formatRegionOptions(regions))
    if (currentRegion) {
      updateValue(currentRegion)
    }
  }, [regions])

  const updateValue = (newValue: number) => {
    if (newValue === selected) {
      return
    }
    setSelected(newValue)
    updateRegion(newValue, setSearchParams)
  }

  if (!selected || !options.length) {
    return <Spinner />
  }
  return (
    <Select
      big={big}
      depth={2}
      options={options}
      defaultValue={selected}
      onChange={handleChange}
    />
  )
}
SelectRegion.defaultProps = {
  big: false,
}
export default connector(SelectRegion)
